import { fileDownload } from 'utils/fileDownload';
import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const giftCodeApi = {
    createCodes: async (formData) => {
        const url = `api/giftCodes/v1/system/batches`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(formData),
        });
    },
    downloadCodes: async (id) => {
        const filename = `gift_codes_batch_${id}.csv`;
        const url = `api/giftCodes/v1/system/batches/${id}/csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, filename);
            }
        } catch (e) {
            logError(e);
        }
    },
    getSystemCodeBatches: async () => {
        const url = `api/giftCodes/v1/system/batches`;
        return mmFetchWithResponse(url);
    },
};

export { giftCodeApi };
